import React, { useState } from "react";
import { useCreateRole } from "../../../../store/query/roleQuery";
import { useToast } from "../../../../contexts-hooks/hooks/useToster";
import { useFormik } from "formik";
import * as Yup from "yup";

const useCreateRoles = () => {
  const [isCreating, setIsCreating] = useState(false);
  const { showToast } = useToast();
  const createRoleMutation = useCreateRole();

  const handleCreateRole = (role) => {
    setIsCreating(true);
    createRoleMutation.mutate(
      { role: role },
      {
        onSuccess: () => {
          setIsCreating(false);
          showToast("Role created successfully");
          formik.resetForm();
        },
        onError: (err) => {
          setIsCreating(false);
          showToast("Role already exists", "error");
        },
      }
    );
  };

  const formik = useFormik({
    initialValues: { role: "" },
    onSubmit: (values) => {
      handleCreateRole(values.role);
    },
    validationSchema: Yup.object({
      role: Yup.string().required("Role is required"),
    }),
  });

  return {
    formik,
    isCreating,
  };
};

export default useCreateRoles;
